import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@common/hooks';
import { SummaryBar } from './summary-bar';

export function StaffingRequestBar({
  showState,
  showDropDown,
  staffingRequest,
}) {
  return (
    <>
      <SummaryBar
        showState={showState}
        showDropDown={showDropDown}
        staffingRequest={staffingRequest}
      />
    </>
  );
}

StaffingRequestBar.propTypes = {
  showState: PropTypes.bool,
  showDropDown: PropTypes.bool,
  staffingRequest: PropTypes.object.isRequired,
};

StaffingRequestBar.defaultProps = {
  showState: true,
  showDropDown: false,
};

StaffingRequestBar.fragment = gql`
  fragment StaffingRequestBarFragment on StaffingRequest {
    id
    ...SummaryBarFragment
  }
  ${SummaryBar.fragment}
`;
